import classNames from "classnames";
import React from "react";
import { buildBackgroundGradientClassName } from "../elements/BackgroundGradient";
import { Separator } from "../elements/Separator";
import {
  HalfWidthClassName,
  HalfWidthTextClassName,
  MainShortWidthClassName,
  MainWidthClassName,
} from "../styles";

export const TextHero: React.FC<{
  title?: string | null;
  heading?: string | null;
  description?: string | null;
}> = ({ title, heading, description }) => {
  return (
    <section data-component="Text Hero" className="relative">
      <div
        className={classNames(
          "absolute h-1/3 w-full",
          buildBackgroundGradientClassName("Short", "Hyacinth"),
        )}
      />
      <div className="page-grid max-width relative pb-30px pt-90px lg:pb-48px lg:pt-96px">
        {title && (
          <h1
            className={classNames(
              "h3 text-hyacinth",
              HalfWidthClassName,
              "pt-20px",
              "lg:row-start-2",
            )}
          >
            {title}
          </h1>
        )}
        {heading && (
          <h2
            className={classNames(
              "h1 text-coal",
              MainShortWidthClassName,
              "pt-20px",
              "lg:row-start-3 lg:pt-40px",
            )}
          >
            {heading}
          </h2>
        )}
        {description && (
          <>
            <Separator
              className={classNames(MainWidthClassName, "lg:row-start-4")}
            />
            <p
              className={classNames(
                "p1 text-coal lg:row-start-5",
                HalfWidthTextClassName,
              )}
            >
              {description}
            </p>
          </>
        )}
      </div>
    </section>
  );
};
